import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-leaflet-task-validity-indicator',
  templateUrl: './leaflet-task-validity-indicator.component.html',
  styleUrls: ['./leaflet-task-validity-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeafletTaskValidityIndicatorComponent {
  @Input() validMin: number | null = null;
  @Input() validMax: number | null = null;
  @Input() isValid: boolean | null = null;
  @Input() color: string | null = null;
}
